import { Button } from "primereact/button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 2rem;
`;

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Container>
      <h1>404</h1>
      <h4>{t("header-404-not-found")}</h4>
      <Button
        label={t("label-go-to-login")}
        onClick={() => navigate("/login")}
      />
    </Container>
  );
};

export default NotFound;
